import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import LoginPage from '../pages/LoginPage';
import HomePage from '../pages/HomePage';
import PlayersPage from '../pages/PlayersPage';
import PlayerDetailPage from '../pages/PlayerDetailPage';
import AuctionsPage from '../pages/AuctionsPage';
import AuctionDetailPage from '../pages/AuctionDetailPage';
import AuctionAnalysisPage from '../pages/AuctionAnalysisPage';
import DataSyncBootstrap from '../components/DataSyncBootstrap';
import InfoPage from '../pages/InfoPage';
import FantaQuizzPage from '../pages/FantaQuizzPage';
import ScambiPage from '../pages/ScambiPage';
import StrategiesPage from '../pages/StrategiesPage';
import StrategyEditPage from '../pages/StrategyEditPage';
import SimulaRosaPage from '../pages/SimulaRosaPage';
import PanoramicaSquadraPage from '../pages/PanoramicaSquadraPage';
import useFantasyDataSyncing from '../hooks/useFantasyDataSyncing';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) return <div style={{ padding: 24 }}>Caricamento...</div>;
  if (!user) return <Navigate to="/login" replace />;

  return (
    <>
      <DataSyncBootstrap />
      {children}
    </>
  );
}

// Blocca l'accesso diretto (URL, back/forward) alle pagine delle aste finché
// la sincronizzazione dati è in corso: gli acquisti registrati su dati non
// ancora aggiornati potrebbero essere incoerenti.
function AuctionsGuard({ children }) {
  const { syncing } = useFantasyDataSyncing();

  if (syncing) return <Navigate to="/" replace />;

  return children;
}

function PublicRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) return <div style={{ padding: 24 }}>Caricamento...</div>;
  if (user) return <Navigate to="/" replace />;

  return children;
}

export default function AppRouter() {
  return (
    <Routes>
      <Route path="/login" element={<PublicRoute><LoginPage /></PublicRoute>} />
      <Route path="/" element={<ProtectedRoute><HomePage /></ProtectedRoute>} />
      <Route path="/players" element={<ProtectedRoute><PlayersPage /></ProtectedRoute>} />
      <Route path="/players/:id" element={<ProtectedRoute><PlayerDetailPage /></ProtectedRoute>} />
      <Route path="/aste" element={<ProtectedRoute><AuctionsGuard><AuctionsPage /></AuctionsGuard></ProtectedRoute>} />
      <Route path="/aste/:auctionId" element={<ProtectedRoute><AuctionsGuard><AuctionDetailPage /></AuctionsGuard></ProtectedRoute>} />
      <Route path="/aste/:auctionId/analisi" element={<ProtectedRoute><AuctionsGuard><AuctionAnalysisPage /></AuctionsGuard></ProtectedRoute>} />
      <Route path="/info" element={<ProtectedRoute><InfoPage /></ProtectedRoute>} />
      <Route path="/quiz" element={<ProtectedRoute><FantaQuizzPage /></ProtectedRoute>} />
      <Route path="/scambi" element={<ProtectedRoute><ScambiPage /></ProtectedRoute>} />
      <Route path="/strategie" element={<ProtectedRoute><StrategiesPage /></ProtectedRoute>} />
      <Route path="/strategie/:strategyId" element={<ProtectedRoute><AuctionsGuard><StrategyEditPage /></AuctionsGuard></ProtectedRoute>} />
      <Route path="/strategie/pubblica/:ownerUid/:strategyId" element={<ProtectedRoute><AuctionsGuard><StrategyEditPage /></AuctionsGuard></ProtectedRoute>} />
      <Route path="/simula-rosa" element={<ProtectedRoute><AuctionsGuard><SimulaRosaPage /></AuctionsGuard></ProtectedRoute>} />
      <Route path="/panoramica-squadra" element={<ProtectedRoute><AuctionsGuard><PanoramicaSquadraPage /></AuctionsGuard></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}